<template>
  <div v-if="isPickup" class="shipping-notice checkout" style="margin-left: -1.25em">
    <template v-if="isPickupAndDeliveryNotGermany">
      <h4 className="pt-1">{{ $translate('KrauseSohn::Template.checkoutNoShippingForeignCountries') }}</h4>
      <p>{{ $translate('KrauseSohn::Template.checkoutNoShippingForeignCountriesDescription') }}</p>
    </template>
    <h4>Wichtig!</h4>
    <p v-html="$translate('KrauseSohn::Template.pickupNotice')"></p>
    <div className="form-check">
      <label htmlFor="checkPickup" className="form-check-label">
        {{ $translate('KrauseSohn::Template.checkoutPickUpOptInText') }}
      </label>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NotificationService from "../../services/NotificationService";
import TranslationService from "../../services/TranslationService";

export default {
  name: "pick-up-opt-in",
  data()
  {
    return {
      checkPickup: false,
      isSet: false
    }
  },
  computed:
      {
        isPickupAndDeliveryNotGermany()
        {
          if (this.shippingProfileId == parseInt(App.configKS.checkout.shippingSpeditionPickup))
          {
            // 1 is Germany
            if (this.shippingCountryId != 1)
            {
              return true;
            }
          }
        },
        isPickup()
        {
          if (this.shippingProfileId == parseInt(App.configKS.checkout.shippingSpeditionPickup))
          {
            return true;
          }
          return false;
        },
        ...mapState({
          shippingProfileId: state => state.checkout.shipping.shippingProfileId,
          shippingCountryId: state => state.localization.shippingCountryId
        })
      }
}
</script>
